<template>
    <div class="main-header">
        <div class="container--main">
            <div class="main-header--wrap">
                <div class="main-header--info-text">
                    <img src="images/renova-logo.png" alt="Renova" class="login--logo" width="159">
<!--                    <div class="info">-->
<!--                        <div class="info&#45;&#45;wrap">-->
<!--                            <span class="info&#45;&#45;badge">Důležité</span>-->
<!--                            <span class="info&#45;&#45;text">Blíží se lhůta výměny vašeho zařízení. Prosím obraťte se na <span class="info&#45;&#45;link">servisního technika</span></span>-->
<!--                        </div>-->
<!--                    </div>-->
                  <structure-group v-bind="currentDashboard"></structure-group>
                </div>
                <div class="main-header--info-main">
<!--                    <div class="notification">-->
<!--                        <div class="notification&#45;&#45;button">-->
<!--                            <svg class="notification&#45;&#45;button&#45;&#45;icon notification&#45;&#45;button&#45;&#45;icon&#45;&#45;active" xmlns="http://www.w3.org/2000/svg" width="19" viewBox="0 0 18.35 22.36"><title>Notification</title><path d="M16.26,16.28l2.3,2.29v1.15H.21V18.57L2.5,16.28V10.55C2.5,7,4.37,4.08,7.66,3.3V2.52a1.72,1.72,0,1,1,3.44,0V3.3c3.28.78,5.16,3.73,5.16,7.25ZM9.38,23.16a2.29,2.29,0,0,1-2.29-2.29h4.59a2.3,2.3,0,0,1-2.3,2.29Z" transform="translate(-0.21 -0.8)"/></svg>-->
<!--                            <span class="notification&#45;&#45;button&#45;&#45;number">3</span>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="notification">-->
<!--                        <div class="notification&#45;&#45;button">-->
<!--                            <svg class="notification&#45;&#45;button&#45;&#45;icon" xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 20 16"><title>Message</title><path d="M10,9,2,4V2l8,5,8-5V4ZM2,0A2,2,0,0,0,0,2V14a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V2a2,2,0,0,0-2-2Z" transform="translate(0)"/></svg>-->
<!--                            <span class="notification&#45;&#45;button&#45;&#45;number">0</span>-->
<!--                        </div>-->
<!--                    </div>-->
                    <nav class="menu">
                      <ul class="menu--ul">
                        <li class="menu--li js-active">
                          <a href="" class="menu--li--link">Nástěnka</a>
                        </li>
                      </ul>
                    </nav>
                    <div class="client-info">
                        <div class="client-info--name--wrap">
                            <span class="client-info--name--text">{{ user.fullName }}</span>
                        </div>
<!--                        <div class="client-info&#45;&#45;photo&#45;&#45;wrapper">-->
<!--                            <div class="client-info&#45;&#45;photo&#45;&#45;wrap">-->
<!--                                <img :src="user.profilePictureLink" alt="" class="client-info&#45;&#45;photo&#45;&#45;img">-->
<!--                            </div>-->
<!--                        </div>-->
                        <div class="client-info--dropdown">
<!--                            <a href="" class="client-info&#45;&#45;dropdown&#45;&#45;link">Uživatelské nastavení</a>-->
                            <a href="#" @click="logout" class="client-info--dropdown--link">Odhlásit se</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { mapState } from 'vuex'
  import StructureGroup from "../Widgets/StructureGroup";
  export default {
    name: "MainHeader",
    components: {StructureGroup},
    methods: {
      logout: function(){
        this.$store.commit('user/logout');
        this.$router.push({ name: 'Login' });
      }
    },
    computed: {
        ...mapState('user',['user'])
    }
  }
</script>

<style scoped lang="less">
    .main-header {
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        /*padding: 0 0 0 180px;*/
        // Removed sidebar
        padding: 0;
        box-shadow: 0 0.375rem 1.188rem rgba(0, 0, 0, 0.04);
        background: #ffffff;
        z-index: 9;
        &--wrap {
            display: flex;
            align-items: center;
            justify-content: space-between;
            min-height: 70px;
        }
        &--info-text {
          display: flex;
          align-items: center;
        }
        &--info-main {
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

  .client-info {
    color: #C9CAD4;
    &:hover {
      color: #083E89;
      cursor: pointer;
    }
    &--name {
      &--text {
        font-size: 14px;
        color: currentColor;
      }
    }
  }
  .menu {
    &--ul {
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &--li {
      color: #C9CAD4;
      font-size: 14px;
      position: relative;
      &:before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 20px;
        right: 20px;
        background: #F9A51B;
        height: 3px;
      }
      &--link {
        color: currentColor;
        padding: 25px 20px;
        display: block;
      }
      &.js-active {
        color: #083E89;
        font-weight: 500;
      }
    }
  }
</style>
